<template>
  <div class="company_right company_hidden" ref="container">
    <!-- id不存在 or 没有权限 -->
    <div v-if="!id || !allKey.COMPANY_DETAIL" class="noData no_data_container">
      <span class="img no_data_img"></span>
      <p>Sorry, No data was found</p>
    </div>

    <div v-else class="company_container noPadding">
      <p class="company_common_title fixCls" :style="{ width: fixedWidth + 'px' }">
        <span>{{ companyName }}</span>
        <span
          :class="favouriteStatus ? 'isFavorite' : 'isNFavorite'"
          class="favourite_btn"
          @click="setFavouriteStatus"
        ></span>
        <span class="home-btn" @click="setIndexShow"></span>
      </p>
      <div class="tab_">
        <el-tabs
          v-model="activeName"
          @tab-click="tabClick"
          :class="{ otherCountry: currentDataSource == 'bvd' }"
        >
          <el-tab-pane name="first">
            <span slot="label">
              <span class="maker"></span> Basic Information
            </span>
            <basic v-if="activedList.includes('first')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </basic>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label">
              <span class="maker"></span> Corporate Ownership
            </span>
            <corporate v-if="activedList.includes('second')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </corporate>
          </el-tab-pane>
          <el-tab-pane name="third">
            <span slot="label">
              <span class="maker"></span> Financials
            </span>
            <financials v-if="activedList.includes('third')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </financials>
          </el-tab-pane>
          <!-- <el-tab-pane name="fourth">
            <span slot="label">
              <span class="maker"></span> Financials for listed companies
            </span>
            <financials-companies v-if="activedList.includes('fourth')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </financials-companies>
          </el-tab-pane>
          <el-tab-pane name="fifth">
            <span slot="label">
              <span class="maker"></span> Operation and MarketPerformance
            </span>
            <operation v-if="activedList.includes('fifth')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </operation>
          </el-tab-pane> -->
          <!-- 2022.5.20 - 添加上市公司深度资料 -- 市场表现比较、市值分析比较、盈利预测比较、财务比率比较、财务数据比较 -- tt -->
          <!--<el-tab-pane name="sixth">
            <span slot="label">
              <span class="maker"></span> Market performance comparison
            </span>
            <comparison :country="country" v-if="activedList.includes('sixth')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </comparison>
          </el-tab-pane>
          <el-tab-pane name="seventh">
            <span slot="label">
              <span class="maker"></span> Market value analysis and comparison
            </span>
            <comparison :country="country" v-if="activedList.includes('seventh')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </comparison>
          </el-tab-pane>
          <el-tab-pane name="eighth">
            <span slot="label">
              <span class="maker"></span> Profit forecast comparison
            </span>
            <comparison :country="country" v-if="activedList.includes('eighth')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </comparison>
          </el-tab-pane>
          <el-tab-pane name="ninth">
            <span slot="label">
              <span class="maker"></span> Financial ratio comparison
            </span>
            <comparison :country="country" v-if="activedList.includes('ninth')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </comparison>
          </el-tab-pane>
          <el-tab-pane name="tenth">
            <span slot="label">
              <span class="maker"></span> Financial data comparison
            </span>
            <comparison :country="country" v-if="activedList.includes('tenth')">
              <info-data :dataSources="dataSources" :updated="updated" slot="info"></info-data>
            </comparison>
          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import TableForm from "common/components/tableForm";
import InfoData from "./components/Info";
import Basic from "./components/companyCom/Basic";
import Corporate from "./components/companyCom/Corporate";
import Financials from "./components/companyCom/Financials";
import FinancialsCompanies from "./components/companyCom/FinancialsCompanies";
import Operation from "./components/companyCom/Operation";
import Comparison from "./components/companyCom/Comparison";

import { mapState, mapMutations } from "vuex";

import {
  postSaveFavourite,
  getFavouriteStatus,
  delFavouriteData
} from "common/js/http/v2Api";

export default {
  components: {
    TableForm,
    Basic,
    Corporate,
    InfoData,
    Financials,
    FinancialsCompanies,
    Operation,
    Comparison
  },

  data() {
    return {
      fixedWidth: 0,
      // id: "",
      dataSources: "BVD",
      updated: "06/27/2018",
      companyName: this.$route.query.companyName,
      activeName: "first",
      activedList: ["first"], //保证只加载一次tab content
      favouriteStatus: false,
      favouriteId: null,
      userId: parseInt(this.Cookies.get("imsilkroad_userid")),
      country: {}
      // userId: 1
    };
  },

  created() {
    this.setWidth();
    //获取收藏状态
    this.getFaStat();
  },

  computed: {
    id() {
      return this.$route.query.id;
    },
    ...mapState({
      collapseStatus(state) {
        return state.Collapse.isCollapse;
      },

      currentDataSource(state) {
        return state.DataSource.dataSource;
      },

      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  },

  methods: {
    setWidth() {
      this.$nextTick(() => {
        const paddingWidh = 20;
        const width = this.$refs.container.clientWidth;
        // this.fixedWidth = width - paddingWidh * 2;
        this.fixedWidth = width;
        // 设置内置元素的宽度
        let tabNavHeader = document.getElementsByClassName(
          "el-tabs__header"
        )[0];
        tabNavHeader.style.width = this.fixedWidth + "px";
      });
    },

    setData() {
      this.companyName = this.$route.query.companyName;
    },

    tabClick(tab, event) {
      if (!this.activedList.includes(this.activeName)) {
        this.activedList.push(this.activeName);
      }
      if (tab.name == "seventh") {
        this.country = {name: "Market value analysis and comparison"};
      }
      if (tab.name == "sixth") {
        this.country = {name: "Market performance comparison"};
      }
      if (tab.name == "eighth") {
        this.country = {name: "Profit forecast comparison"};
      }
      if (tab.name == "ninth") {
        this.country = {name: "Financial ratio comparison"};
      }
      if (tab.name == "tenth") {
        this.country = {name: "Financial data comparison"};
      }
      document.getElementById("route_right").scrollTo(0, 0);
    },

    setFavouriteStatus() {
      //准备收藏
      if (!this.favouriteStatus) {
        // module收藏数据类型 1 企业 2 并购 3 行业 4 指标

        let params = {
          companyId: this.id,
          module: 1,
          params: window.location.href,
          title: "",
          userId: this.userId
        };
        this.$prompt("Please enter a title", "Notice", {
          confirmButtonText: "sure",
          cancelButtonText: "cancle"
        }).then(({ value }) => {
          params.title = value;
          this.saveFavorite(params);
        });
      }
      //取消收藏
      else {
        this.delFavori(this.favouriteId);
      }
    },

    //收藏
    async saveFavorite(params) {
      const { result } = await postSaveFavourite(params);
      // Collection of success
      this.$message({
        message: "Collection of success!",
        type: "success"
      });
      this.favouriteStatus = !this.favouriteStatus;
    },

    //取消收藏
    async delFavori(id) {
      const { result } = await delFavouriteData(id);
      // Cancel Successful
      this.$message({
        message: "Cancel Successful!",
        type: "success"
      });
      this.favouriteStatus = !this.favouriteStatus;
    },

    async getFaStat() {
      //companyid, userid
      const { result } = await getFavouriteStatus(this.id, this.userId);
      //无结果代表未收藏
      if (!result) {
        this.favouriteStatus = false;
      } else {
        this.favouriteId = result.id;
        this.favouriteStatus = true;
      }
    },

    setIndexShow() {
      this.changeIndexShow(true);
    },

    ...mapMutations(["changeIndexShow", "companyActiveMenu"])
  },

  watch: {
    $route(newValue) {
      this.activeName = "first";
      this.activedList = [];
      this.$nextTick(() => {
        //下次更新dom完毕后 添加   避免直接添加v-if起不到效果  组件不重新加载
        this.activedList.push("first");
      });
      this.setData();
      
      this.setWidth();
      console.log("$route -> setWidth")
    },

    collapseStatus() {
      setTimeout(() => {
        this.setWidth();
      }, 600);
      // 展开收缩有一个动画延迟  如果不延迟则  会获取动画开始前的宽度 而不是之后的宽度
    },

    id() {
      this.getFaStat();
    }
  }
};
</script>

<style scoped>
.otherCountry >>> .el-tabs__header #tab-fifth,
.otherCountry >>> .el-tabs__header #tab-fourth {
  display: none;
}
.favourite_btn,
.home-btn {
  position: absolute !important;
}
</style>
